//
//
//
//
//
//
//
//
//
//
import BeatLoader from "vue-spinner/src/BeatLoader.vue";
export default {
  props: {
    height: {
      type: String,
      default: "auto"
    },
    color: {
      type: String,
      required: false,
      default: "#141E47"
    },
    size: {
      type: String,
      required: false,
      default: "15px"
    }
  },
  components: {
    BeatLoader: BeatLoader
  },
  name: "Loader"
};